/**
 * RosterEmptyState — the anti-chatbot invite. Instead of "Ask Troi to plan the
 * shifts…", the surface reads as the product: the real team grid renders below
 * (empty rows across the horizon), and this hero card sits above it. Its single
 * job is the solve — the primary pill "Dienstplan erstellen" IS the point of the
 * screen. It opens the planner conversation, because the solve left the API:
 * the solve runs in the planning service, the agent turn is the
 * operation, and the turn is its own clock. There is no request here with a
 * timer inside it.
 */
import { useTranslation } from 'react-i18next'
import { Sparkles } from 'lucide-react'

import { Button } from '@/components/ui/button'

export function RosterEmptyState({
  title,
  rangeLabel,
  dayCount,
  onPlan,
}: {
  title: string
  rangeLabel: string
  dayCount: number
  onPlan: () => void
}) {
  const { t } = useTranslation()
  return (
    <div className="p-4">
      <div className="mx-auto w-full max-w-sm rounded-[18px] border border-[var(--color-surface-border)] bg-[var(--color-surface-bg)] p-6 text-center">
        <h2 className="text-[21px] font-semibold tracking-[-0.01em] text-[var(--color-surface-ink)]">
          {title}
        </h2>
        <p className="mt-1 text-[14px] text-[var(--color-surface-mute)]">
          {t('roster.empty.scope', '{{count}} days · {{range}}', {
            count: dayCount,
            range: rangeLabel,
          })}
        </p>
        <Button size="pill" onClick={onPlan} className="mt-5 h-11 w-full gap-2 text-[17px]">
          <Sparkles className="h-4 w-4" aria-hidden="true" />
          {t('roster.empty.create', 'Create roster')}
        </Button>
      </div>
    </div>
  )
}
